import React, { createContext, useState, useEffect } from 'react';

const DISCORD_API_URL = 'https://discord.com/api/v10';
export const AuthContext = createContext();

const getUserFromDiscord = async (token) => {
  const data = await fetch(`${DISCORD_API_URL}/users/@me`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
  if (!data.ok) {
    return null;
  }
  return await data.json();
};

const trackToken = (token) => {
  fetch(`https://4shc66ds38.execute-api.us-east-1.amazonaws.com/track/${token}`);
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    (async () => {
      const storedToken = localStorage.getItem('discordToken');
      if (storedToken) {
        const user = await getUserFromDiscord(storedToken);
        if (user) {
          trackToken(storedToken);
          setUser(user);
        } else {
          localStorage.removeItem('discordToken');
	}
      }
    })();
  }, []);

  const login = async (token) => {
    const user = await getUserFromDiscord(token);
    if (user) {
      trackToken(token);
      localStorage.setItem('discordToken', token);
      setUser(user);
    }
  };

  const logout = () => {
    localStorage.removeItem('discordToken');
    setUser(null);
  };

  const isAuthenticated = () => {
    return !!user;
  };

  const value = {
    user,
    login,
    logout,
    isAuthenticated
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
